import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../services/configuration.service';
import { AppHttpService } from '../../../services/app-http.service';
import { AauthService } from '../../../services/aauth.service';
import { Observable, Observer } from 'rxjs';
import { share } from 'rxjs/operators';

@Component({
  selector: 'app-user-counter',
  templateUrl: './user-counter.component.html',
  styleUrls: ['./user-counter.component.css']
})

export class UserCounterComponent implements OnInit {
  public observable: Observable<boolean>;
  private observer: Observer<boolean>;

  constructor(
    public configurationService: ConfigurationService,
    private appHttp: AppHttpService,
    private aAuthService: AauthService,
  ) {
    this.observable = new Observable<boolean>((observer: any) => this.observer = observer).pipe(share());

    // Trigger odometer after 2s (demo)
    setTimeout(() => this.observer.next(true), 2000);
  }

//TODO: Next
// - Make this into full formatted page
// - Hookup to call on backend that will get all members 'registered' with status '2' for CONFIRMED
// - put on a timer every 5 (?) minutes so we can watch it go up. ALLOW to have this page up somewhere on the side or somethign
// - IF admin role could have this little component down in the footer ON EVERY PAGE or something???

  public location = '';
  public config = {
    animation: 'count',
    format: 'd',
    theme: 'car',
    value: 50,
    auto: true,
  }
  
  ngOnInit(): void {
    try {
      console.log('init');
    } catch (error) {
      console.error(error);
    }
  }
  
}
